import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Globe } from 'react-bootstrap-icons';
import { Languages } from '../../../enums/languages';
import style from '../../../styles/components/layout.module.css';
import { useGetLanguageApp, useSetLanguageApp } from '../../../stores/app.store';
import { getLanguageLabel } from '../../../helpers/language';


const LanguageSelect = () => {

    const [isHovered, setIsHovered] = useState(false);
    const setLanguage = useSetLanguageApp();
    const currentLanguage = useGetLanguageApp();

    const currentLanguageLabel = getLanguageLabel(currentLanguage);

    return (
        <div
            className={style.dropdown}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className={style.languageSelectContainer} style={{ display: 'flex', alignItems: 'center' }}>
                <Globe />

                <div className={style.currentLanguage}>{currentLanguageLabel}</div>

                {isHovered ? <ChevronUp className={style.arrow} /> : <ChevronDown className={style.arrow} />}
            </div>

            <div
                className={style.languageSelectOptions}
                style={{
                    display: isHovered ? 'block' : 'none',
                }}
            >
                <div className={style.languageSelectOption} onClick={() => handleOnClicked(Languages.Hebrew)}>עברית</div>
               
                <div className={style.languageSelectOption} onClick={() => handleOnClicked(Languages.English)}>English</div>
            </div>
        </div>
    );
// <div className={style.languageSelectOption} onClick={() => handleOnClicked(Languages.Arabic)}>العربية</div>
    function handleOnClicked(language: Languages) {

        setIsHovered(false);
        setLanguage(language);
    }

}



export default LanguageSelect;